import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { AccountService } from '../services/account.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-dashboard',
  imports: [RouterOutlet, MenuModule, ButtonModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  title = 'Dashboard';
  items: MenuItem[] = [];

  constructor(private accountService: AccountService, private router: Router) { }

  ngOnInit(): void {
    const menuItems: MenuItem[] = [
      {
        label: 'Meus Cupons',
        icon: 'pi pi-ticket',
        routerLink: '/dashboard/cupom-parceiro',
      },
      // {
      //   label: 'Solicitações de Saque'
      // },
      // {
      //   label: 'Cupons',
      //   routerLink: '/dashboard/cupons'
      // },
      // {
      //   label: 'Loja (pacotes)'
      // },
      // {
      //   label: 'Compras na loja'
      // },
      // {
      //   label: 'FAQ'
      // },
      // {
      //   label: 'Mensagens do Sistema'
      // },
      // {
      //   label: 'Usuários' //tela de perfil, tela de batalhas e tela banco
      // },
      // {
      //   label: 'Parceiros' //tela de parceiros/streamers
      // },
    ];

    if (this.accountService.isStaff()) {
      menuItems.push({
        label: 'Cupons',
        icon: 'pi pi-ticket',
        routerLink: '/dashboard/cupons',
      });
      menuItems.push({
        label: 'Usuários',
        icon: 'pi pi-users',
        routerLink: '/dashboard/users-info',
      });
      menuItems.push({
        label: 'Funil de Usuários',
        icon: 'pi pi-chart-bar',
        routerLink: '/dashboard/user-funnel',
      });
      menuItems.push({
        label: 'Solicitações Trusted',
        icon: 'pi pi-shield',
        routerLink: '/dashboard/trusted-requests',
      });
      menuItems.push({
        label: 'Transações',
        icon: 'pi pi-wallet',
        routerLink: '/dashboard/transactions',
      });
      menuItems.push({
        label: 'Batalha',
        icon: 'pi pi-trophy',
        routerLink: '/dashboard/battle-list',
      });
      menuItems.push({
        label: 'Resultados',
        icon: 'pi pi-chart-line',
        routerLink: '/dashboard/resultados',
      });
      menuItems.push({
        label: 'Financeiro',
        icon: 'pi pi-dollar',
        disabled: true,
        styleClass: 'admin-menu-section',
      });
      menuItems.push({
        label: 'Resumo',
        icon: 'pi pi-chart-line',
        routerLink: '/dashboard/financial/resumo',
        styleClass: 'admin-menu-section-item',
      });
      menuItems.push({
        label: 'Detalhes',
        icon: 'pi pi-table',
        routerLink: '/dashboard/financial/detalhes',
        styleClass: 'admin-menu-section-item',
      });
      menuItems.push({
        label: 'Entradas e Saídas',
        icon: 'pi pi-sliders-h',
        routerLink: '/dashboard/financial/entradas-saidas',
        styleClass: 'admin-menu-section-item',
      });
      menuItems.push({
        label: 'Aquisição de Moedas/Gemas',
        icon: 'pi pi-chart-pie',
        routerLink: '/dashboard/financial/aquisicao',
        styleClass: 'admin-menu-section-item',
      });
      menuItems.push({
        label: 'Ligas',
        icon: 'pi pi-star',
        routerLink: '/dashboard/ligas',
      });
      menuItems.push({
        label: 'Temporadas',
        icon: 'pi pi-calendar',
        routerLink: '/dashboard/temporadas',
      });
      menuItems.push({
        label: 'Campanhas de Marketing',
        icon: 'pi pi-megaphone',
        routerLink: '/dashboard/campaigns',
      });
      menuItems.push({
        label: 'Missões extras',
        icon: 'pi pi-megaphone',
        routerLink: '/dashboard/missions',
      })
      menuItems.push({
        label: 'Anúncios',
        icon: 'pi pi-bell',
        routerLink: '/dashboard/announcements',
      })
    }

    this.items = menuItems;
  }

  logout(): void {
    // Chama o método do serviço para limpar os dados do usuário da memória
    this.accountService.logout();
    // Redireciona o usuário para a rota raiz ('/') que é a sua tela de login
    this.router.navigate(['/']);
  }
}
